import React from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";

import Dashboard from "./Modules/Dashboard/DashboardContainer";
import Login from "./Modules/Login/LoginContainer";
import Authenticate from "./Modules/Login/AuthenticateContainer";
import initialize from "./Utilities/initializeState";
import { loginSuccessAction, loginFailAction } from "./Modules/Login/Actions/LoginActions";

class Home extends React.Component {
  constructor( props ) {
    super( props );
    initialize( props );
  }

  render() {
    let authToken = sessionStorage.getItem( "Auth-Token" );
    let username = sessionStorage.getItem( "username" );

    return (
      <Switch>
        <Route exact path="/login" render = { () => {
          return authToken && username && authToken.length > 4
            ? (this.props.isAppreciationsEnabled ? <Redirect exact to="/appreciation" /> : <Redirect exact to="/redemption" />)
            : <Login props={ { ...this.props } } />;
        } } />
        <Route exact path="/authenticate" render = { () => {
          return <Authenticate props={ { ...this.props } } />;
        } } />
        <Route path="/" render = { () => {
          return authToken && username && authToken.length > 4
            ? <Dashboard />
            : <Redirect exact to="/login" />;
        } } />

      </Switch>
    );
  }
}

// https://indrive-pwa.skordev.com/#/external-redirect/?employee_id=suryanov901&app_name=indrive&url=dashboard&timestamp=1667996021&token=a9bf7683ee482bb47fdeb707c5d584ecf6d6055f9bca433067c93d67353ee3f1&sub_domain=indrive&uuid=3de645e6-dc38-4523-b8ac-ac7d3e107d46

const mapStateToProps = state => {
  return {
    authToken: state.Login.authToken,
    username: state.Login.username,
    isAppreciationsEnabled: state.Login.isAppreciationsEnabled
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loginSucceed: ( payload ) => dispatch( loginSuccessAction( payload ) ),
    loginFail: ( payload ) => dispatch( loginFailAction( payload ) )
  };
};

export default withRouter( connect( mapStateToProps, mapDispatchToProps )( Home ) );